/* AuthCallback — cattura session_id dal fragment #session_id=... dopo il ritorno
   da https://auth.emergentagent.com, lo scambia con il backend per un session_token
   persistente in cookie httpOnly, poi naviga alla dashboard corretta in base al ruolo.
   REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH */
import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    // Pulisci il fragment dall'URL prima possibile
    window.history.replaceState(null, "", window.location.pathname);

    (async () => {
      try {
        const r = await axios.post(
          `${BACKEND}/api/auth/google-session`,
          { session_id },
          { withCredentials: true }
        );
        const user = r.data?.user;
        if (user) {
          // Salva user metadata per l'AuthProvider / UI
          try { localStorage.setItem('emergent_user', JSON.stringify(user)); } catch {}
          const role = user.role || "customer";
          const dest = ["super_admin", "admin", "operator", "operatore", "dipendente"].includes(role)
            ? "/admin/dashboard"
            : "/dashboard";
          toast.success(`Benvenuto ${user.nome || user.email}`);
          navigate(dest, { replace: true, state: { user } });
        } else {
          throw new Error("Sessione invalida");
        }
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Login Google fallito");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="animate-spin h-12 w-12 border-4 border-white/20 border-t-[#ff0033] rounded-full mx-auto mb-4" />
        <p className="text-sm text-white/60">Autenticazione in corso…</p>
      </div>
    </div>
  );
}
